module.exports = __webpack_public_path__ + "static/media/KMH_4979.63ee6143.jpg";